// extracted by mini-css-extract-plugin
module.exports = {"root":"PackagePrice_root__1Svgf","amount":"PackagePrice_amount__1jx3M","unit":"PackagePrice_unit__1ClYc","badge":"PackagePrice_badge__2N7RY"};